import { Component, OnInit,Inject, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { FacebookService, InitParams,UIParams, UIResponse } from 'ngx-facebook';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { UserService } from "projects/hp-api/src/lib/services/user.service";
import { WizardHpBaseComponent } from '../../base/wizard/wizard-hp-base-component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-social-medias',
  templateUrl: './social-medias.component.html',
  styleUrls: ['./social-medias.component.css']
})
export class SocialMediasComponent  implements OnInit {
  lastData=[{
    "photo_name":"",
    "pdf": ""
   }];
   emailForm: FormGroup;
   submitted = false;
   email_socialMedia = false;
  email_ok = false;
  cwData:any;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService,private userService: UserService, router: Router,
    public fmail: FormBuilder,
    private fb: FacebookService,
    private _bottomSheetRef: MatBottomSheetRef<SocialMediasComponent>,@Inject(DOCUMENT) private document: Document) {
    //super(chgDetectorRef, hpService, router);
    this. lastData=[];
    //this.lastData.push(this.getHpService().getLastdata());
 
   }

  ngOnInit() {
    this.emailForm = this.fmail.group({
      email: ['', [Validators.required,Validators.email]]
      
  });

  }

  share() {
 
    const params: UIParams = {
     
      method: 'feed',
      display: 'popup',
      name:"Simulateur de portes swao",
      href: 'https://simulateur.simuleo.com/swao',
      caption: 'Simulateur de portes swao',
      picture: 'https://simulateur.simuleo.com/simulation/photos/'+this.lastData[0].photo_name+'.jpg',
      description: "Simulateur de portes swao"
      
    };
   
    this.fb.ui(params)
      .then((res: UIResponse) => console.log(res))
      .catch((e: any) => console.error(e));
   
  }


  onSubmit() {
    this.submitted = true;
  
    // stop here if form is invalid
    if (this.emailForm.invalid) {
        return;
    }
    this.email_ok = true;
    this.userService.sendPdfMail(this.emailForm.value.email,this.lastData[0].pdf).subscribe(data => { 
        this.email_ok = true;
  
    }); 
  }
  getErrorMessage() {
    if (this.emailForm.controls.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.emailForm.controls.email.hasError('email') ? 'Not a valid email' : '';
  }

  /*
get formControl for fields
*/
get f() { return this.emailForm.controls; }

 /**
   * 
   * @param str 
   * Encoding UTF-8 --> base64
   * @returns 
   */
 b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
  }))
}

}
